import host from './host';

export default `${host}/admin`;
